import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepsActions } from '../../store/modules/steps/reducer';
import { stepsSelector } from '../../store/modules/steps/selectors';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';

const Sidebar: React.FC<Record<string, unknown>> = () => {

	const dispatch = useDispatch()
	const { steps, activeStepIndex } = useSelector(stepsSelector)
	const jumpToStep = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, stepIndex: number): void => {
		e && e.preventDefault();
		if (stepIndex < activeStepIndex) dispatch(stepsActions.setRequestedStep(stepIndex))
	}

	return (
		<ul>
			{steps?.map((step, stepIndex) => {

				const activeLi = stepIndex === activeStepIndex ? 'uk-active' : ''
				const activeBadge = stepIndex < activeStepIndex
					? ({
						className: 'badge-success',
						content: <IconRenderer {
							...{
								icon: 'check',
								shape: 'circle',
								size: 18,
								color: '#fff',
								viewbox: '2 2 18 18'
							}
						} />
					})
					: ({
						className: '',
						content: stepIndex + 1
					})

				return (
					<li key={step.stepName} className={`${activeLi}`}>
						<button  {...{ type: 'button', className: 'list-btn', onClick: e => jumpToStep(e, stepIndex) }}>
							<span className={`uk-badge badge ${activeBadge?.className}`}>
								{activeBadge?.content}
							</span>
							{step.stepTitle}
						</button>
					</li>
				)
			})
			}
		</ul>
	);
};

export default Sidebar;
